import { useEffect, useRef, useState } from "react";

export default function useFetch(url, methodHttp, headers , bodyHttp ) {

    const isMounted = useRef(true);
    const [state, setState] = useState({});

    useEffect(() => {
        return () => {
            isMounted.current = false;
        }
    }, [])

    useEffect(() => {
        setState({ data: null, loading: true, error: null })
        const token = sessionStorage.getItem('authToken') || localStorage.getItem('authToken');

        try {
            fetch(url, {
                method: methodHttp,
            headers: {...headers, 'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`},
            body : JSON.stringify(bodyHttp)
            })
            .then(r => r.json())
            .then(d => {

            isMounted.current &&
                setState({
                    loading: false,
                    error: d.error,
                    data: d.data,
                    status: d?.status 
                })


            })
        } catch (error) {
            setState({
                loading: false,
                error: error,
                data: null
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [url])

    return state;
}